/**
* @license Apache-2.0
*
* Copyright (c) 2021 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MAIN //

/**
* Tests if a value is an empty array-like object.
*
* @param {*} value - value to test
* @returns {boolean} boolean indicating if a value is an empty array-like object
*
* @example
* var bool = isEmptyArrayLikeObject( [] );
* // returns true
*
* @example
* var bool = isEmptyArrayLikeObject( { 'length': 0 } );
* // returns true
*
* @example
* var bool = isEmptyArrayLikeObject( '' );
* // returns false
*/
function isEmptyArrayLikeObject( value ) {
	return (
		typeof value === 'object' &&
		value !== null &&
		value.length === 0
	);
}


// EXPORTS //

module.exports = isEmptyArrayLikeObject;
